<template>
  <div class="content" id="content">
    <login v-if="!isLogin()"></login>
    <div v-else-if="!isUploadState()">
      <div v-if="getUserInfo()!=null" class="music-nav-area">
        <div class="music-user-info">
          <img :src="getUserInfo().headImgIconUrl" class="user-icon">
          <div class="user-area">
            <p class="user-nickname">{{getUserInfo().nickname}}
              <a href="javascript:void(0)" class="back-account" @click="requestExitAccount">退出当前账号</a>
            </p>
            <p class="user-desc">ID: {{getUserInfo().uid+10000}}</p>
          </div>
          <div class="upload_btn">
            <input class="music-upload" value="上传歌曲" type="button" @click="musicUploadGo()">
            <input class="music-upload-video" value="上传视频" type="button" @click="musicUploadVideo()">
          </div>
        </div>
      </div>
      <div class="music-li-body" v-if="musicList != null">
        <div class="music-li-head">
          <p class="music-head-title">
            <img src="../assets/music_mark_normal.png" class="music-head-tag">
            <!-- <span>已上传</span> -->
            <!-- <span class="musicTab" @click="changeTab(0)">音乐</span>
            <span class="musicTab" @click="changeTab(1)">视频</span> -->
            <span :class="isShow == true ? 'musicView': 'musicTab'" @click="changeTab(0)">已上传音乐</span>
            <span :class="isShow == false ? 'musicView': 'musicTab'" @click="changeTab(1)">已上传视频</span>
          </p>
          <input type="button" value="删除" class="music-delete" @click="clickDeleteMusic">
        </div>

        <div class="music-body" v-show="isShow">
          <table class="music-body-table">
            <tr class="th">
              <th width="40%"><label :class="['music-check-base ', musicCheckAll?'checked':'']" @click="checkMusicAll"/>名称
              </th>
              <th width="30%">演唱者</th>
              <th width="8%">大小</th>
              <th width="8%">状态</th>
              <th width="14%">时间</th>
            </tr>
          </table>
          <table v-if="musicList && musicList.length > 0">
            <tr v-for="(item,index) in musicList" :key="'item-'+index" class="music-item-tr">
              <td width="40%"><label :class="['music-check-base ', item.checked?'checked':'']"
                                     @click="checkMusicItem(index)"/>{{item['m_name']}}
              </td>
              <td width="30%">{{item['m_singer']}}</td>
              <td width="8%">{{getComputeSize(item['m_size'])}}</td>
              <td width="8%">{{item['state']==0?'未审核':(item['state']==1?'通过':(item['state']==-1?'未通过':'其他'))}}</td>
              <td width="14%">{{getDateFormat(item['m_create_date'])}}</td>
            </tr>
          </table>
          <div v-else class="music-empty">
            <img src="../assets/music_empty_normal.png">
            <p>空空如也~快去上传你喜欢的歌曲吧！</p>
          </div>

          <div class="page-nav">
            <div class="page-li"><span class="page-li-left" @click="clickLastPage">&lt;</span><span class="page-li-content">{{musicListPage}}/{{musicListPageTotal}}</span><span
              class="page-li-right" @click="clickNextPage">&gt;</span></div>
              <span class="totalNum">总共{{musicTotalCnt}}条</span>
          </div>
        </div>
        <div class="music-body" v-show="!isShow">
          <table class="music-body-table">
            <tr class="th">
              <th width="25%"><label :class="['music-check-base ', musicCheckAll?'checked':'']" @click="checkMusicAll"/>名称
              </th>
              <th width="15%">类型</th>
              <th width="30%">导演</th>
              <th width="8%">大小</th>
              <th width="8%">状态</th>
              <th width="14%">时间</th>
            </tr>
          </table>
          <table v-if="musicList && musicList.length > 0">
            <tr v-for="(item,index) in musicList" :key="'item-'+index" class="music-item-tr">
              <td width="25%"><label :class="['music-check-base ', item.checked?'checked':'']"
                                     @click="checkMusicItem(index)"/><span class="itemSpan">{{item['name']}}</span>
              </td>
              <!-- <td width="15%">
                <span v-if="item['tag_id']==1">电影</span>
                <span v-else-if="item['tag_id']==2">综艺</span>
                <span v-else-if="item['tag_id']==3">动画</span>
                <span v-else-if="item['tag_id']==4">爱情</span>
                <span v-else-if="item['tag_id']==5">恐怖</span>
                <span v-else>{{item['tag_id']}}</span>
              </td> -->
              <td width="15%">{{getTagName(item['tag_id'])}}</td>
              <td width="30%">{{item['director']}}</td>
              <td width="8%">{{getComputeSize(item['size'])}}</td>
              <td width="8%">{{item['state']==0?'未审核':(item['state']==1?'审核通过':(item['state']==-1?'审核未通过':'其他'))}}</td>
              <td width="14%">{{getDateFormat(item['create_date'])}}</td>
            </tr>
          </table>
          <div v-else class="music-empty">
            <img src="../assets/music_empty_normal.png">
            <p>空空如也~快去上传你喜欢的电影吧！</p>
          </div>

          <div class="page-nav">
            <div class="page-li"><span class="page-li-left" @click="clickLastPage">&lt;</span><span class="page-li-content">{{musicListPage}}/{{musicListPageTotal}}</span><span
              class="page-li-right" @click="clickNextPage">&gt;</span></div>
              <span class="totalNum">总共{{musicTotalCnt}}条</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="isUploadState()">
      <div v-if="this.pageState1 == 0">
        <div class="music-nav-area nav-area-small">
          <div class="music-upload-head">
            <p><a href="javascript:void(0)" class="back-account" @click="backMusicList(0)">&lt;&lt; 查看我已上传的歌曲</a></p>
          </div>
        </div>
        <div class="upload-content">
          <div class="upload-item-li">
            <label>歌曲名</label><span class="red-tag">*</span><span class="label-tips">（必填，不超过20个字）</span>
            <p class="item-p">
              <input type="text" maxlength="20" class="input-music-info" v-model="musicName"
                    @input="changeMusicName"><span
              :class="'input-tips '+ (nameErrMsg?'show':'hide')">（*{{nameErrMsg}}）</span>
            </p>
          </div>
          <div class="upload-item-li">
            <label>演唱者</label><span class="red-tag">*</span><span class="label-tips">（必填，不超过20个字，确保信息准确，否则会导致下架）</span>
            <p class="item-p">
              <input type="text" maxlength="20" class="input-music-info" v-model="musicSinger" @input="changeMusicSinger"><span
              :class="'input-tips '+ (singerErrMsg?'show':'hide')">（*{{singerErrMsg}}）</span>
            </p>
          </div>
          <div class="upload-item-li">
            <label>上传音乐文件</label><span class="red-tag">*</span><span class="label-tips">（必填，仅限mp3格式，不超过20M）</span>
            <p class="item-p">
              <span class="btn-input" @click="clickChooseFile">选择音乐文件</span>
              <span class="file-name" :class="musicFileName?'show':'hide'">{{musicFileName}}</span>
              <input type="file" value="选择文件" class="input-choose-file" name="file" accept="audio/mpeg" id="choose-file"
                    @change="changeMusicFile">
              <span :class="'input-tips '+ (fileErrMsg?'show':'hide')">（*{{fileErrMsg}}）</span>
            </p>
          </div>

          <div class="upload-action-area">
            <p class="protocol"><input type="checkbox" class="protocol-box" v-model="protocolChecked"><span
              class="protocol-choose">我已认真阅读并同意<router-link to="/privacy">《恋爱物语用户协议》</router-link></span></p>
            <div class="upload-action-area-ly">
              <input type="button" class="upload-action-button" value="确认上传" @click="clickUpload">
              <div :class="(uploadProgress>0?'show':'hide') + ' upload-area'">
                <svg class="svg" width="44px" height="44px">
                  <circle cx="22" cy="22" r="20" fill="none" stroke="rgba(19, 201, 41, 0.3)" stroke-width="4"
                          stroke-linecap="round"/>
                  <circle class="upload-circle-inner" cx="22" cy="22" r="20" fill="none" stroke="rgba(19, 201, 41, 1)"
                          stroke-width="4" :stroke-dasharray="uploadProgress+',10000'"/>
                </svg>
                <span class="span">{{(uploadProgress/Math.floor(2*Math.PI * 20)).toFixed(2)*100}}%</span>
                <span class="upload-text">正在上传中...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <!-- 上传视频 -->
        <div class="music-nav-area nav-area-small">
          <div class="music-upload-head">
            <p><a href="javascript:void(0)" class="back-account" @click="backMusicList(1)">&lt;&lt; 查看我已上传的视频</a></p>
          </div>
        </div>
        <div class="upload-content">
          <div class="upload-item-li">
            <label>视频名称</label><span class="red-tag">*</span><span class="label-tips">（必填，不超过20个字）</span>
            <p class="item-p">
              <input type="text" maxlength="20" class="input-music-info" v-model="vedioName"
                    @input="changeMovieName"><span
              :class="'input-tips '+ (vedioErrMsg?'show':'hide')">（*{{vedioErrMsg}}）</span>
            </p>
          </div>
          <div class="upload-item-li">
            <label>导演</label><span class="red-tag">*</span><span class="label-tips">（必填，不超过20个字）</span>
            <p class="item-p">
              <input type="text" maxlength="20" class="input-music-info" v-model="actor" @input="changeActor"><span
              :class="'input-tips '+ (actorErrMsg?'show':'hide')">（*{{actorErrMsg}}）</span>
            </p>
          </div>
          <div class="upload-item-li">
            <label>视频分类</label>
            <p class="item-p">
              <select v-model="tagId" :label-in-value="true" class="selectView">
                <option
                  v-for="(item,index) in tagList"
                  :key="index"
                  :label="item.name"
                  :value="item.id">
                </option>
            </select>
            </p>
          </div>
          <div class="upload-item-li">
            <label>封面</label><span class="red-tag">*</span><span class="label-tips">（必填，比例2:1，最小分辨率600*300）</span>
            <p class="item-p">
              <span class="btn-input" @click="clickChooseFile1">选择封面文件</span>
              <span class="file-name" :class="imageFileName?'show':'hide'">{{imageFileName}}</span>
              <input type="file" value="选择文件" class="input-choose-file" name="file" accept="image/*" id="choose-file1"
                    @change="changeImageFile">
              <span :class="'input-tips '+ (imageErrMsg?'show':'hide')">（*{{imageErrMsg}}）</span>
              <!-- <span class="input-tips ">（*{{fileErrMsg}}）</span> -->
            </p>
          </div>
          <div class="upload-item-li">
            <label>上传视频文件</label><span class="red-tag">*</span><span class="label-tips">（必填，格式必须是mp4/rmvb/mkv/avi/wmv，大小不超过5G）</span>
            <p class="item-p">
              <span class="btn-input" @click="clickChooseFile2">选择视频文件</span>
              <span class="file-name" :class="vedioFileName?'show':'hide'">{{vedioFileName}}</span>
              <input type="file" value="选择文件" class="input-choose-file" name="file" accept=".mp4,.wmv,.rmvb,.mkv,.avi" id="choose-file2"
                    @change="changeVedioFile">
              <span :class="'input-tips '+ (vedioFileErrMsg?'show':'hide')">（*{{vedioFileErrMsg}}）</span>
            </p>
          </div>

          <div class="upload-action-area">
            <p class="protocol"><input type="checkbox" class="protocol-box" v-model="protocolChecked"><span
              class="protocol-choose">我已认真阅读并同意<router-link to="/privacy">《恋爱物语用户协议》</router-link></span></p>
            <div class="upload-action-area-ly">
              <input type="button" class="upload-action-button" value="确认上传" @click="clickUploadMovie">
              <div :class="(uploadProgress>0?'show':'hide') + ' upload-area'">
                <svg class="svg" width="44px" height="44px">
                  <circle cx="22" cy="22" r="20" fill="none" stroke="rgba(19, 201, 41, 0.3)" stroke-width="4"
                          stroke-linecap="round"/>
                  <circle class="upload-circle-inner" cx="22" cy="22" r="20" fill="none" stroke="rgba(19, 201, 41, 1)"
                          stroke-width="4" :stroke-dasharray="uploadProgress+',10000'"/>
                </svg>
                <span class="span">{{(uploadProgress/Math.floor(2*Math.PI * 20)).toFixed(2)*100}}%</span>
                <span class="upload-text">正在上传中...</span>
              </div>
            </div>
            <p class="label-tips1" style="margin: 20px 0 10px 25px; font-size: 18px;">上传分享视频须知：</p>
            <p class="label-tips1">1、上传的视频、封面必须符合国家相关的<span>法律及行政法规</span>的要求，严禁上传任何包含反对<span>宪法所确定</span>的基本原则、危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一、破 坏民族团结、损害国家荣誉和利益、煽动民族仇恨、民族歧视、破坏民族团结、破坏国家宗教政策、宣扬邪教和封建迷信、淫秽、色情露点及明显性暗示、赌博、暴力、凶杀、恐怖、 国内外限制级以上或者教唆犯罪、侮辱或者诽谤他人，侵害他人合法权益的内容，或其他令人反感的的内容（包括但不限于资讯、资料、文字、软件、音乐、照片、图形、信息或其他资料等）。
            </p>
            <p class="label-tips1">2、不得上传各视频及音乐网站的会员、付费、独播、自制类享有<span>独家播放权</span>的内容，或上述网站明示不得下载、传播的内容，因上传侵权内容造成的法律后果，由<span>用户自行承担</span>。
            </p>
            <p class="label-tips1">3、用户上传的视频内容仅用于用户本人及语音房朋友间欣赏之用，不得用于任何商业用途；“恋爱物语”仅为上传用户提供存储空间；如果“恋爱物语”发现用户有违反法律法规规定，或《恋爱物语用户协议》，或本“须知”之情形，恋爱物语有权删除视频内容。
            </p>
          </div>
        </div>
      </div>
      
    </div>
    
    <div class="tips" :class="{on: tips!=''}">
      <p>{{ tips }}</p>
    </div>
    <div class="common-dialog" :class="{on: dialogContent!=''}">
      <div class="common-dialog-body">
        <span class="common-dialog-close" @click="clickDialogClose"></span>
        <p class="common-dialog-content">{{dialogContent}}</p>
        <div class="common-dialog-action">
          <a href="javascript:void(0);" :class="['common-dialog-button','left', hideDialogLeft?'hide':'']" @click="clickDialogLeft">取消</a>
          <a href="javascript:void(0);" class="common-dialog-button right" @click="clickDialogRight()">确定</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Login from '@/components/login'
  import {Params, getSessionId, setSessionId, getComputeSize, getDateFormat, getTagName} from '@/util/util.js'
  import Qs from 'qs'
  import * as qiniu from 'qiniu-js'

  export default {
    name: 'UploadMusic',
    data() {
      return {
        pageState: 0,
        pageState1: 0,
        musicTotalCnt: 0,
        musicCheckAll: false,
        musicList: null,
        uploadProgress: Math.floor(2 * Math.PI * 0),
        musicListPage: 1,
        musicListPageTotal: 1,
        protocolChecked: 1,
        musicName: '',
        musicSinger: '',
        musicFileName: '',
        tips: '',
        dialogContent:'',
        dialogMode:this.GLOBAL.DIALOG_MODE_TIPS,
        hideDialogLeft:true,
        nameErrMsg: '',
        singerErrMsg: '',
        fileErrMsg: '',
        uploadToken: '',
        actor: '',
        actorErrMsg: '',
        vedioName: '',
        vedioErrMsg: '',
        vedioFileName: '',
        vedioFileErrMsg: '',
        imageFileName: '',
        imageErrMsg: '',
        tagId: '1',
        tagList: '',
        imageUrl: '',
        movieUrl: '',
        isShow: true,
        stopStatus: true
      }
    },
    methods: {
      // 获取上传视频类型
      getTagIdList: function(){
        const that = this;
        var params = new Params(that, {
          method: 'movie.tag.list.web'
        });
        this.$axios.post(that.$store.state.urlData.url, Qs.stringify(params), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (res) {
          if (res.data.errCode == 0) {
            // console.log('tagId', res.data)
            that.tagList = res.data.data ? res.data.data : ''
          } else {
            that.showTips(res.data.errMsg, that);
          }
        });
      },
      isLogin: function () {
        return this.getUserInfo() != null;
      },
      isUploadState: function () {
        return this.pageState === this.GLOBAL.PAGE_STATE_UPLOAD;
      },
      getUserInfo: function () {
        return this.$store.state.loginAccount;
      },
      musicUploadGo: function () {
        this.pageState = this.GLOBAL.PAGE_STATE_UPLOAD;
        this.pageState1 = 0
      },
      musicUploadVideo: function () {
        this.pageState = this.GLOBAL.PAGE_STATE_UPLOAD;
        this.pageState1 = 1
        // this.getTagIdList()
      },
      checkMusicAll: function (event) {
        var value = !this.musicCheckAll;
        if (this.musicList && this.musicList.length > 0) {
          for (var i = 0; i < this.musicList.length; i++) {
            this.$set(this.musicList[i], 'checked', value);
          }
        }
        this.musicCheckAll = value;
      },
      checkMusicItem: function (index) {
        if (index < 0 || index >= this.musicList.length) {
          return;
        }
        var value = !this.musicList[index].checked;
        this.$set(this.musicList[index], 'checked', value);
        if (!value) {
          this.musicCheckAll = false;
        }
      },
      backMusicList: function (val) {
        this.pageState = this.GLOBAL.PAGE_STATE_MUSIC_LIST;
        console.log('返回按钮', this.pageState)
        this.isShow = val == 0 ? true : false
        this.requestMusicList()
      },
      // 上传视频-提交
      clickUploadMovie: function (event) {
        console.log('上传视频按钮启动', this.imageUrl)
        if (this.protocolChecked <= 0) {
          this.showTips("请先认真阅读处CP用户协议", this);
          return;
        }
        var node1 = document.getElementById('choose-file1');
        var node2 = document.getElementById('choose-file2');
        this.changeImageFile();
        this.changeVedioFile();
        this.changeMovieName();
        this.changeActor();
        // console.log('vedioErrMsg1 vedioErrMsg', this.vedioErrMsg)
        // console.log('vedioErrMsg2', this.vedioName)
        // console.log('vedioErrMsg3 actorErrMsg', this.actorErrMsg)
        // console.log('vedioErrMsg4', this.actor)
        // console.log('vedioErrMsg5 imageErrMsg', this.imageErrMsg)
        // console.log('vedioErrMsg6', this.imageFileName)
        // console.log('vedioErrMsg7 vedioFileErrMsg', this.vedioFileErrMsg)
        // console.log('vedioErrMsg8', this.vedioFileName)
        // console.log('vedioErrMsg8 movieUrl', this.movieUrl)
        if (this.vedioErrMsg || this.actorErrMsg || this.imageErrMsg || this.vedioFileErrMsg) {
          console.log('1111上传电影前判断')
          return;
        }
        var that = this;
        event.preventDefault();
        var params = new Params(that, {
          name: that.vedioName,
          director: that.actor,
          tagId: that.tagId,
          coverUrl: that.imageUrl,
          url: that.movieUrl,
          method: 'movie.upload.web'
        });
        
        var config = {
          onUploadProgress: progressEvent => {
            var complete = (progressEvent.loaded / progressEvent.total | 0)
            that.uploadProgress = Math.floor(2 * Math.PI * 20 * complete);
          }
        };
        this.$axios.post(that.$store.state.urlData.url, Qs.stringify(params), {
        // this.$axios.post(that.$store.state.urlData.wapUrl + "?method=movie.upload.web", Qs.stringify(params), config, {
        // this.$axios.post('/api' + "?method=movie.upload.web", Qs.stringify(params), config, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (res) {
          console.log(res);
          if (res && res.data && res.data.errCode == 0) {
            that.uploadProgress = 0;
            that.tagId = "1";
            that.vedioName = "";
            that.vedioErrMsg = "";
            that.actor = "";
            that.actorErrMsg = "";
            that.imageErrMsg = "";
            that.imageFileName = "",
            that.imageUrl = '';
            that.vedioFileErrMsg = '';
            that.vedioFileName = "";
            that.movieUrl = '';
            that.$store.commit('setNeedLoadMusic', 1);
            that.backMusicList(1)
          } else {
            that.uploadProgress = 0;
            that.showTips(res && res.data ? res.data.errMsg:"服务器异常", that);
          }
        });
      },
      // 上传音乐-提交
      clickUpload: function (event) {
        if (this.protocolChecked <= 0) {
          this.showTips("请先认真阅读处CP用户协议", this);
          return;
        }
        var node = document.getElementById('choose-file');
        this.changeMusicFile();
        this.changeMusicName();
        this.changeMusicSinger();
        if (this.fileErrMsg || this.nameErrMsg || this.singerErrMsg) {
          return;
        }
        var that = this;
        event.preventDefault();
        var params = new Params(that, {
          'm_singer': that.musicSinger,
          'm_name': that.musicName
        });
        let formData = new FormData();
        for (const key in params) {
          formData.append(key, params[key]);
        }
        formData.append("music_file", node.files[0]);
        
        var config = {
          onUploadProgress: progressEvent => {
            var complete = (progressEvent.loaded / progressEvent.total | 0)
            that.uploadProgress = Math.floor(2 * Math.PI * 20 * complete);
          }
        };
        console.log(formData);
        console.log(config);
        
        this.$axios.post(that.$store.state.urlData.wapUrl + "?method=musicUpload", formData, config, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            "Access-Control-Allow-Origin": "*",
            'Access-Control-Allow-Methods':'POST',
            'Access-Control-Allow-Headers':'x-requested-with,content-type'
          }
        }).then(function (res) {
          console.log(res);
          if (res && res.data && res.data.errCode == 0) {
            that.showTips("上传成功", that);
            that.uploadProgress = 0;
            that.musicName = "";
            that.musicSinger = "";
            that.musicFileName = "";
            that.nameErrMsg = "";
            that.singerErrMsg = "";
            that.fileErrMsg = "";
            that.$store.commit('setNeedLoadMusic', 1);
            that.backMusicList(0)
          } else {
            that.uploadProgress = 0;
            that.showTips(res && res.data ? res.data.errMsg:"服务器异常", that);
          }
        });
      },
      requestIsLogin: function () {
        const that = this;
        var params = new Params(that, {
          method: 'login.confirm.web'
        });
        this.$axios.post(that.$store.state.urlData.url, Qs.stringify(params), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (res) {
          if (res.data.errCode == 0) {
            that.$store.commit('setLoginAccount', res.data.data);
            that.$store.commit('setLoginAccountList', null);
            that.$store.commit('setLoginState', that.GLOBAL.LOGIN_STATE_DONE);
            that.$store.commit('setNeedLoadMusic', 1);
          } else {
            // that.showTips(res.data.errMsg, that);
          }
        });
      },
      requestExitAccount: function () {
        const that = this;
        var params = new Params(that, {
          method: 'logout.web'
        });
        this.$axios.post(that.$store.state.urlData.url, Qs.stringify(params), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (res) {
          if (res.data.errCode == 0) {
            setSessionId('');
            that.$store.commit('setLoginAccount', null);
            that.$store.commit('setLoginState', that.GLOBAL.LOGIN_STATE_PART0);
          } else {
            that.showTips(res.data.errMsg, that);
          }
        });
      },
      requestMusicList: function (paramPage) { //请求音乐列表
        const that = this;
        var params = new Params(that, {
          page: paramPage,
          type: that.isShow == true ? 0 : 1,
          method: 'music.upload.list.web'
        });
        this.$axios.post(that.$store.state.urlData.url, Qs.stringify(params), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (res) {
          if (res.data.errCode == 0) {
            // that.musicListPageTotal = res.data.data['page_total'];
            // that.musicList = res.data.data['music_list'];
            // that.musicListPage = res.data.data['page_number'];
            // that.musicTotalCnt = res.data.data['upload_total'];

            // that.musicListPage = that.musicListPage==0?1:that.musicListPage;
            // that.musicListPageTotal = that.musicListPageTotal==0?1:that.musicListPageTotal;
            // that.musicList = that.musicList == null ? [] : that.musicList;
            that.musicListPageTotal = res.data.data['page_total'];
            that.musicList = that.isShow == true ? res.data.data['music_list'] : res.data.data['video_list'];
            that.musicListPage = res.data.data['page_number'];
            that.musicTotalCnt = res.data.data['upload_total'];

            that.musicListPage = that.musicListPage==0?1:that.musicListPage;
            that.musicListPageTotal = that.musicListPageTotal==0?1:that.musicListPageTotal;
            that.musicList = that.musicList == null ? [] : that.musicList;
          } else {
            that.showTips(res.data.errMsg, that);
          }
        });
      },
      // 选取音乐按钮
      clickChooseFile: function (event) {
        var node = document.getElementById('choose-file');
        node.click(event);
      },
      // 选取封面按钮
      clickChooseFile1: function (event) {
        var node = document.getElementById('choose-file1');
        node.click(event);
        this.getToken();
      },
      // 选取视频按钮
      clickChooseFile2: function (event) {
        var node = document.getElementById('choose-file2');
        node.click(event);
        this.getToken();
        this.stopStatus = false;
        console.log('stopStatus', this.stopStatus)
      },
      clickDeleteMusic: function(){
        var checkedIds='';
        let musicSize = this.musicList ? this.musicList.length:0;
        if(musicSize>0){
          for(var i in this.musicList){
            var temp = this.musicList[i];
            if(temp.checked){
              // checkedIds +=temp['m_id']+',';
              if (this.isShow == true) {
                checkedIds +=temp['m_id']+',';
              } else {
                checkedIds +=temp['movieId']+',';
              }
            }
          }
        }
        if(!checkedIds){
          this.showDialog("你没有选中任何一项", this.GLOBAL.DIALOG_MODE_TIPS);
        }else{
          this.showDialog("你确定要删除吗？", this.GLOBAL.DIALOG_MODE_DEL);
        }
      },
      deleteMusic:function(){
        var checkedIds='';
        let delCount=0;
        let musicSize = this.musicList ? this.musicList.length:0;
        if(musicSize>0){
          for(var i in this.musicList){
            var temp = this.musicList[i];
            if(temp.checked){
              // checkedIds +=temp['m_id']+',';
              if (this.isShow == true) {
                checkedIds +=temp['m_id']+',';
              } else {
                checkedIds +=temp['movieId']+',';
              }
              
              delCount++;
            }
          }
        }
        if(!checkedIds){
          this.showDialog("你没有选中任何歌曲", this.GLOBAL.DIALOG_MODE_TIPS);
          // this.showTips("你没有选中任何歌曲", this);
          return;
        }
        checkedIds = checkedIds.substring(0, checkedIds.length-1);
        const that = this;
        var params = ''
        if (that.isShow == true) {
          params = new Params(that, {
            'm_ids':  checkedIds,
            method: 'music.delete.web'
          });
        } else {
          params = new Params(that, {
            'v_ids':  checkedIds,
            method: 'music.delete.web'
          });
        }
        this.$axios.post(that.$store.state.urlData.url, Qs.stringify(params), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (res) {
          if (res.data.errCode == 0) {
            that.showDialog("成功删除", that.GLOBAL.DIALOG_MODE_TIPS);
            // that.showTips("删除成功", that);
            that.$store.commit('setNeedLoadMusic',delCount==musicSize? 1 : that.musicListPage);
          } else {
            that.showTips(res.data.errMsg, that);
          }
        });
      },
      clickLastPage:function(){
        if(this.musicListPage == 1 || this.musicListPageTotal == 1){
          return;
        }
        this.requestMusicList(this.musicListPage-1);
      },
      clickNextPage:function(){
        if(this.musicListPage == this.musicListPageTotal || this.musicListPageTotal == 1){
          return;
        }
        this.requestMusicList(this.musicListPage+1);
      },
      changeMusicFile: function () {
        var node = document.getElementById('choose-file');
        var file = node.files && node.files.length > 0 ? node.files[0]: null;
        console.log(file);
        var name = file ? file.name : '';
        if (name) {
          this.musicFileName = name;
        }
        this.fileErrMsg = this.musicFileName ? "" : "未选择文件";

        var fileSize = file && file.size ? file.size : 0;
        if(fileSize > 20 * 1024 * 1024){
          this.fileErrMsg = "音乐文件不超过20M";
        }
      },
      // 获取token
      getToken: function () {
        const that = this;
        var params = new Params(that, {
          method: 'qiniu.sign.check.h5'
        });
        this.$axios.post(that.$store.state.urlData.url, Qs.stringify(params), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (res) {
          if (res.data.errCode == 0) {
            that.uploadToken = res.data.data.upload_token ? res.data.data.upload_token : ''
          } else {
            that.showTips(res.data.errMsg, that);
          }
        });
      },
      changeImageFile: function () {
        var node = document.getElementById('choose-file1');
        var file = node.files && node.files.length > 0 ? node.files[0]: null;
        var uploadToken = this.uploadToken
        var name = file ? file.name : '';
        // var name = null;

        var fileSize = file && file.size ? file.size : 0;
        // if(fileSize > 20 * 1024 *1024){
        //   console.log('55')
        //   this.imageErrMsg = "图片不超过20M";
        //   console.log('kkk', this.imageErrMsg)
        // }

        let config = {
          useCdnDomain: true,   //表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
          region: qiniu.region.z2     // 根据具体提示修改上传地区,当为 null 或 undefined 时，自动分析上传域名区域
        };
        let putExtra = {
          fname: "",  //文件原文件名
          params: {}, //用来放置自定义变量
          mimeType: null  //用来限制上传文件类型，为 null 时表示不对文件类型限制；限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
        };
        let that = this
        if (file) {
          let observe = {
            next(res){
              // console.log('observer', res)
              that.imageErrMsg = "图片上传中，请稍后~";
            },
            error(err){
              console.log('observer2', err)
              that.imageErrMsg = "图片上传失败啦~";
              that.imageFileName = ''
              that.imageUrl = ''
            }, 
            complete(res){
              that.imageUrl = res.url
              that.imageFileName = name;
              that.imageErrMsg = that.imageFileName ? "" : "未选择文件";
              // 判断分辨率
              var reader = new FileReader();
              reader.onload = function (e) {
                var data = e.target.result;
                //加载图片获取图片真实宽度和高度
                var image = new Image();
                image.onload=function(){
                  var width = image.width;
                  var height = image.height;
                  var ratio = width / height
                  console.log('data w', width, 'data h', height, 'ratio', ratio)
                  if( ratio !== 2 || width <600 || height < 300){
                    that.imageErrMsg = "文件分辨率必须大于600*300且宽高比例为2:1";
                    that.imageFileName = ''
                    that.imageUrl = ''
                    console.log('封面url', that.imageUrl)
                    console.log('封面url1', that.imageErrMsg)
                  }
                };
                image.src= data;
              };
              reader.readAsDataURL(file);
            }
          }
          let observable = qiniu.upload(file, null, uploadToken, putExtra, config);
          // let observable = qiniu.upload(file, name, uploadToken, putExtra, config);
          let subscription = observable.subscribe(observe)
        } else {
          that.imageUrl = ''
          that.imageFileName = name;
          that.imageErrMsg = that.imageFileName ? "" : "未选择文件";
        }
        
      },
      changeVedioFile: function () {
        var node = document.getElementById('choose-file2');
        var file = node.files && node.files.length > 0 ? node.files[0]: null;
        console.log('获取视频', file);
        var uploadToken = this.uploadToken
        var name = file ? file.name : '';

        var fileSize = file && file.size ? file.size : 0;
        var fileType = name ? name.substring(name.lastIndexOf(".")) : ''
        let config = {
          useCdnDomain: true,   //表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
          region: qiniu.region.z2     // 根据具体提示修改上传地区,当为 null 或 undefined 时，自动分析上传域名区域
        };
        let putExtra = {
          fname: "",  //文件原文件名
          params: {}, //用来放置自定义变量
          mimeType: null  //用来限制上传文件类型，为 null 时表示不对文件类型限制；限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
        };
        let that = this
        console.log('fileSize11', fileSize < 5120 * 1024 *1024)
        var fileTypeStatus = fileType === '.mp4' || fileType === '.mkv' || fileType === '.rmvb' || fileType === '.avi' || fileType === '.wmv'
        // if (file && fileSize < 5120 * 1024 *1024 && that.movieUrl == '' && fileTypeStatus) {
        if (file && fileSize < 5120 * 1024 *1024 && fileTypeStatus) {
          var observable = qiniu.upload(file, null, uploadToken, putExtra, config);
          // var observable = qiniu.upload(file, name, uploadToken, putExtra, config);
          // if (){
          //   console.log('上传')
          // } else {
          //   console.log('停止')
          //   observable.unsubscribe()
          // }
          console.log('9999')
          observable.subscribe({
            next(res){
              that.vedioFileErrMsg = "视频上传中，请稍后~";
              that.vedioFileName = name;
            },
            error(err){
              console.log('observer2', err)
              that.vedioFileErrMsg = "视频上传失败了~";
              that.movieUrl = ''
              that.vedioFileName = '';
            }, 
            complete(res){
              console.log('observer3', res.url)
              that.movieUrl = res.url
              that.vedioFileName = name;
              console.log('')
              that.vedioFileErrMsg = that.vedioFileName ? "" : "未选择文件";
            }
          })
          // observable.unsubscribe()
        } else if (fileSize > 5120 * 1024 *1024) {
          that.movieUrl = ''
          // that.vedioFileName = name;
          that.vedioFileName = '';
          that.vedioFileErrMsg = "视频文件不超过5G";
        } else if (file && fileTypeStatus === false ) {
          that.movieUrl = ''
          that.vedioFileName = '';
          that.vedioFileErrMsg = "视频格式必须是mp4/rmvb/mkv/avi/wmv";
        } else {
          console.log('进来这里了')
          that.movieUrl = ''
          that.vedioFileName = '';
          that.vedioFileErrMsg = that.vedioFileName ? "" : "未选择文件";
        }
      },
      changeMusicName: function () {
        this.nameErrMsg = this.musicName ? "" : "请输入歌曲名";
        if (this.musicName) {
          this.nameErrMsg = this.musicName.length <= 20 ? this.nameErrMsg : "不能超过20个字";
        }
      },
      changeMusicSinger: function () {
        this.singerErrMsg = this.musicSinger ? "" : "请输入演唱者";
        if (this.musicSinger) {
          this.singerErrMsg = this.musicSinger.length <= 20 ? this.singerErrMsg : "不能超过20个字";
        }
      },
      changeMovieName: function () {
        this.vedioErrMsg = this.vedioName ? "" : "请输入视频名称";
        if (this.vedioName) {
          this.vedioErrMsg = this.vedioName.length <= 20 ? this.movieErrMsg : "不能超过20个字";
        }
      },
      changeActor: function () {
        this.actorErrMsg = this.actor ? "" : "请输入导演";
        if (this.actor) {
          this.actorErrMsg = this.actor.length <= 20 ? this.singerErrMsg : "不能超过20个字";
        }
      },
      clickDialogClose: function(){
        this.dialogContent = '';
        this.dialogMode = this.GLOBAL.DIALOG_MODE_TIPS;
        this.hideDialogLeft = true;
      },
      clickDialogLeft:function(){
        this.dialogContent = '';
        this.dialogMode = this.GLOBAL.DIALOG_MODE_TIPS;
        this.hideDialogLeft = true;
      },
      clickDialogRight:function(){
        if(this.dialogMode == this.GLOBAL.DIALOG_MODE_DEL){
          this.deleteMusic();
        }
        this.dialogContent = '';
        this.dialogMode = this.GLOBAL.DIALOG_MODE_TIPS;
      },
      showDialog: function(value, mode){
        this.dialogMode = mode;
        if(this.dialogMode == this.GLOBAL.DIALOG_MODE_DEL){
          this.hideDialogLeft = false;
        }else{
          this.hideDialogLeft = true;
        }
        this.dialogContent = value;
      },
      showTips: function (tips, that) {
        that.tips = tips;
        setTimeout(() => {
          that.tips = "";
        }, 3000);
      },
      getComputeSize: function (size) {
        return getComputeSize(size);
      },
      getDateFormat: function (time) {
        return getDateFormat(time);
      },
      changeTab: function (val) {
        this.isShow = val ==0 ? true : false
        this.requestMusicList()
      },
      getTagName: function (tag_id) {
        // console.log('tagList', this.tagList)
        return getTagName(tag_id, this.tagList)
      }
    },
    created: function () {
      var contentNode = document.getElementById("content");
      this.pageState = this.GLOBAL.PAGE_STATE_MUSIC_LIST;
      this.$store.commit('inWhichPage', {page: 'isUploadMusic'});
      this.$store.commit('setInitParam', document);
      if (this.$store.state.loginAccount == null || getSessionId() === null || getSessionId() === "") {
        this.requestIsLogin();
      } else {
        this.$store.commit('setNeedLoadMusic', 1);
      }
      // this.getTagIdList()
    },
    computed: {
      fullHeight() {
        return this.$store.state.fullHeight;
      },
      getNeedLoadMusic() {
        return this.$store.state.needLoadMusic;
      }
    },
    watch: {
      getNeedLoadMusic(curVal, oldVal) {
        if (curVal != this.GLOBAL.NO_NEED_LOAD_MUSIC) {
          this.requestMusicList(curVal);
          this.getTagIdList()
        }
        if (curVal != 0) {
          this.$store.commit('setNeedLoadMusic', 0); //恢复原有状态
        }
        // console.log("curVal=" + curVal + ",oldVal=" + oldVal);
      }
    },
    components: {
      Login
    }
  }
</script>
<style scoped>
  .content {
    margin-top: 80px;
    margin-bottom: 40px;
    min-height: 760px;
  }

  .music-nav-area {
    background-color: #F7F7F9;
    padding-top: 40px;
    padding-bottom: 40px;
    margin: 0 auto;
  }

  .nav-area-small {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .music-user-info, .music-li-body, .music-body {
    display: inline-block;
    width: 1080px;
    text-align: left;
    position: relative;
  }

  .music-upload-head, .upload-content {
    display: inline-block;
    width: 800px;
    text-align: left;
    position: relative;
  }

  .music-user-info *, .music-li-head * {
    vertical-align: middle;
  }

  .music-upload {
    width: 180px;
    height: 50px;
    position: absolute;
    z-index: 1;
    right: 200px;
    top: 50%;
    margin-top: -25px;
    border: 0px;
    outline: none;
    font-size: 18px;
    color: #ffffff;
    background-color: #FF8700;
    border-radius: 4px;
    cursor: pointer;
  }
  .music-upload-video {
    width: 180px;
    height: 50px;
    position: absolute;
    z-index: 1;
    right: 0;
    top: 50%;
    margin-top: -25px;
    border: 0px;
    outline: none;
    font-size: 18px;
    color: #ffffff;
    background-color: #FF8700;
    border-radius: 4px;
    cursor: pointer;
  }

  .music-upload:hover {
    opacity: .8;
  }

  .back-account {
    font-size: 14px;
    color: #FF8700;
    font-family: PingFangSC-Medium;
    letter-spacing: 0.5px;
    font-weight: 600;
    cursor: pointer;
    border-bottom: 1px solid #FF8700;
    padding-bottom: 3px;
    text-underline: none;
    display: inline-block;
    margin-left: 5px;
  }

  .user-icon {
    display: inline-block;
    text-align: left;
    width: 96px;
    height: 96px;
    border-radius: 50%;
  }

  .user-area {
    display: inline-block;
    text-align: left;
    margin-left: 10px;
    letter-spacing: 0.3px;
  }

  .user-nickname {
    font-size: 18px;
    color: #232323;
    font-weight: 600;
  }

  .user-desc {
    margin-top: 8px;
    font-size: 16px;
    color: #232323;
    opacity: 0.5;
  }

  .music-li-head {
    padding-top: 40px;
    padding-bottom: 40px;
    position: relative;
  }

  .music-head-tag {
    display: inline-block;
    height: 24px;
    margin-right: 6px;
  }

  .music-head-title {
    font-size: 20px;
    color: #232323;
    font-weight: 700;
  }

  .music-head-desc {
    font-size: 15px;
    color: #232323;
    opacity: 0.5;
    margin-top: 10px;
    padding-left: 25px;
  }

  .music-delete {
    width: 180px;
    height: 50px;
    position: absolute;
    z-index: 1;
    right: 0;
    top: 50%;
    margin-top: -25px;
    border: 1px solid #FF8700;
    outline: none;
    font-size: 18px;
    color: #FF8700;
    background-color: #ffffff;
    border-radius: 4px;
    cursor: pointer;
  }

  .music-delete:hover {
    opacity: 0.6;
  }

  .music-body table {
    width: 100%;
    border-spacing: 0px;
    border-collapse: separate;
  }

  table * {
    vertical-align: middle;
  }

  .music-body table .th {
    height: 50px;
    background-color: #F7F7F9;
    padding: 5px 10px 5px 10px;
  }

  .music-body table tr th {
    display: table-cell;
    padding-left: 10px;
    font-size: 15px;
    color: rgba(35, 35, 35, 0.6);
  }

  .music-item-tr {
    height: 60px;
    font-weight: 600;
  }

  .music-body table tr td {
    display: table-cell;
    padding-left: 10px;
    font-size: 15px;
    color: #232323;
  }

  .music-check-base {
    display: inline-block;
    height: 32px;
    width: 32px;
    outline: none;
    margin-right: 15px;
    background-image: url("../assets/music_rectangle_normal.png");
    background-size: 32px;
  }

  .checked {
    background-image: url("../assets/music_rectangle_selected.png");
  }

  .page-nav {
    padding: 20px 0px;
    text-align: center;
    margin: 0 auto;
  }

  .page-li {
    display: inline-block;
    width: 200px;
    height: 35px;
    text-align: center;
    vertical-align: middle;
  }

  .page-li-left, .page-li-right {
    display: inline-block;
    width: 35px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    cursor: pointer;
    background-color: rgba(216, 216, 216, 0.2);
    font-size: 20px;
    color: #919191;
  }

  .page-li-content {
    display: inline-block;
    text-align: center;
    line-height: 35px;
    width: 70px;
    color: #919191;
    font-size: 16px;
  }

  .music-empty {
    height: 400px;
    text-align: center;
  }

  .music-empty img {
    display: inline-block;
    width: 140px;
    margin-top: 110px;
  }

  .music-empty p {
    font-size: 16px;
    color: #232323;
    margin-top: 18px;
  }

  .music-upload-head .back-account {
    font-size: 18px;
  }

  a, a:hover {
    text-decoration: none;
  }

  .upload-item-li {
    display: block;
    margin-top: 30px;
  }

  .upload-item-li label {
    display: inline-block;
    font-size: 18px;
    font-weight: 700;
  }

  .red-tag {
    color: #FF8700;
    font-size: 18px;
    font-weight: 700;
    vertical-align: middle;
  }

  .upload-item-li .label-tips {
    font-size: 16px;
    color: rgba(35, 35, 35, 0.5);
  }

  .label-tips1 {
    font-size: 14px;
    color: rgba(35, 35, 35, 0.5);
    line-height: 20px;
    margin-left: 25px;
    text-indent: -25px;
  }
  .label-tips1 span {
    color: red;
  }

  .upload-action-area .label-tips {
    font-size: 16px;
    color: rgba(35, 35, 35, 0.5);
    margin-top: 20px;
  }

  .item-p {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .item-p .input-music-info {
    border: 2px solid #E3E3E3;
    border-radius: 4px;
    width: 420px;
    height: 48px;
    font-size: 18px;
    padding: 0 10px;
    outline: none;
    vertical-align: middle;
    box-shadow: none;
  }

  .input-tips {
    font-size: 16px;
    color: #FF8700;
    font-weight: 600;
    margin-left: 10px;
  }

  .input-choose-file {
    display: none;
  }

  .btn-input {
    display: inline-block;
    width: 165px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    font-size: 18px;
    color: #fff;
    background: #2B80FF;
    border-radius: 4px;
    cursor: pointer;
  }

  .file-name {
    margin-left: 5px;
    display: inline-block;
    font-size: 16px;
    color: rgba(35, 35, 35, 0.5);
  }

  .upload-action-area {
    margin-top: 50px;
  }

  .upload-action-area .protocol {
    font-size: 14px;
  }

  .upload-action-button {
    display: inline-block;
    width: 227.5px;
    height: 45px;
    margin-right: 10px;
    line-height: 45px;
    text-align: center;
    font-size: 18px;
    color: #fff;
    border-radius: 4px;
    border: 0px;
    background-color: #FF8700;
    background-size: 227.5px 45px;
    outline: none;
    cursor: pointer;
  }

  .upload-action-button:hover {
    opacity: 0.5;
  }

  .upload-action-area-ly {
    margin-top: 20px;
  }

  .upload-action-area-ly * {
    vertical-align: middle;
  }

  .protocol-box, .protocol-choose {
    display: inline-block;
    vertical-align: middle;
  }

  .protocol-box {
    margin-right: 4px;
  }
  .upload_btn{
    display: flex;
    flex-direction: row;
    
  }
  .selectView {
    width: 200px;
    height: 48px;
    border: 2px solid #E3E3E3;
    border-radius: 4px;
    font-size: 18px;
    padding-left: 10px;
  }
  .musicView {
   background-color:  #FF8700;
   color:white;
   border: 1px solid #FF8700;
   border-radius: 15px;
   padding: 5px 30px;
   margin-right: 15px;
  }
  .musicTab {
    border: 1px solid #E3E3E3;
    border-radius: 15px;
    padding: 5px 30px;
    margin-right: 15px;
  }
 .musicTab:hover {
   cursor: pointer;
   /* background-color: #FF8700; */
   color: #FF8700;;
   border: 1px solid #FF8700;
  }
  .totalNum {
    font-size: 16px;
    color: #919191;
    float: right;
    line-height: 35px;
  }
  .itemSpan {
    display: block;
    margin-left: 47px;
    margin-top: -32px;
    line-height: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/page/upload_music.vue